import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { BrandsDashboardQueryKeys } from "modules/BrandsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { toISOString } from "utils/dateHelperFunctions";

import type { Brand, BrandGroup } from "models";
import type { BrandFormPayload } from "modules/BrandsDashboard/components/BrandModal/hooks";

const updateBrandInBrandGroups = (brandGroups: BrandGroup[], updatedBrand: Brand) =>
  brandGroups.map(group => {
    const brands = group.brands ?? [];
    const brandIdx = brands.findIndex(brand => brand.id === updatedBrand.id);

    if (group.id === updatedBrand.brand_group_id) return { ...group, brands: brandIdx === -1 ? [...brands, updatedBrand] : brands.with(brandIdx, updatedBrand) };
    if (brandIdx === -1) return group;

    return { ...group, brands: brands.toSpliced(brandIdx, 1) };
  });

export const useUpdateBrandMutation = () =>
  useTypedMutation<BrandFormPayload, void>({
    mutationFn: async payload => (await ApiInstance.post("/brands/update", payload, ENV.carBaseURL)).data,
    onSuccess: payload => {
      const previousBrands = typedQueryClient.getQueryData(BrandsDashboardQueryKeys.brands);
      if (!previousBrands) return;

      const brandIdx = previousBrands.findIndex(brand => brand.id === payload.id);
      if (brandIdx === -1) return;

      const brandGroups = typedQueryClient.getQueryData(BrandsDashboardQueryKeys.brandGroups);
      const brand_group_name = brandGroups?.find(group => group.id === payload.brand_group_id)?.name;

      const updatedBrand = { ...previousBrands[brandIdx], ...payload, brand_group_name, updated_on: toISOString(new Date()) };

      typedQueryClient.setQueryData(BrandsDashboardQueryKeys.brands, previousBrands.with(brandIdx, updatedBrand));
      if (!brandGroups) return;

      typedQueryClient.setQueryData(BrandsDashboardQueryKeys.brandGroups, updateBrandInBrandGroups(brandGroups, updatedBrand));
    }
  });
